import { CustomFieldOptionFragment, CustomFieldUsage } from '@/gql/graphql'

export class CustomFieldOption {
  public id: string | null
  public value: string
  public displayOrder: number | null
  // What depends on this option and so stops it being removed. Empty when it can be.
  public removalBlockedBy: CustomFieldUsage[]

  constructor(
    option: Pick<CustomFieldOptionFragment, 'value'> & Partial<CustomFieldOptionFragment>,
  ) {
    this.id = option.id || null
    this.value = option.value
    this.displayOrder = option.displayOrder || null
    this.removalBlockedBy = option.removalBlockedBy ?? []
  }

  get isRemovalBlocked(): boolean {
    return this.removalBlockedBy.length > 0
  }
}
